import api from "./apiClient";

export function initializePayment(formData, depositAmount) {
  return api.post(
    `/api/public/payments/initialize?depositAmount=${encodeURIComponent(
      depositAmount
    )}`,
    formData
  );
}

export function verifyPayment(reference) {
  return api.post(
    `/api/public/payments/verify?reference=${encodeURIComponent(reference)}`
  );
}

export function topUpJob(jobId, token) {
  return api.post(
    `/api/public/payments/topup?jobId=${encodeURIComponent(
      jobId
    )}&token=${encodeURIComponent(token)}`
  );
}

export function getJob(jobId, token) {
  return api.get(
    `/api/public/jobs/${encodeURIComponent(
      jobId
    )}?token=${encodeURIComponent(token)}`
  );
}